import { compose, mdsWidget } from 'dojo/_base/declare';
import dojoDateLocale from 'dojo/date/locale';

const w = window as any;

if (typeof (w.more) == "undefined") {
    w.more = {};
}

if (typeof (w.more.PitHelperStructureFormatType) == "undefined") {
    w.more.PitHelperStructureFormatType = {
        pit: "pit",
        json: "json"
    };
}

class PitHelper extends compose() {
    [key: string]: any;

    _structureFormat: any = null;
    setEntityAttributeValue(entity: any, attributeName: any, value: any, mappingType?: any, overrideStructureFormat?: any): void {
        var attrFound = false;

        var format = this._structureFormat;
        if (overrideStructureFormat == "json" || overrideStructureFormat == "pit") {
            format = overrideStructureFormat;
        }

        if (format == "pit") {

            for (var iIndex = 0; iIndex < entity.Attributes.length; iIndex++) {
                var attribute = entity.Attributes[iIndex];

                if (attribute.Name == attributeName) {
                    attribute.Value = value;
                    if (typeof (mappingType) != "undefined") {
                        attribute.MappingType = mappingType;
                    }

                    attrFound = true;
                    break;
                }
            }

            if (attrFound === false) {

                var newAttr: any = {
                    Name: attributeName,
                    Value: value
                };
                if (typeof (mappingType) != "undefined") {
                    newAttr.MappingType = mappingType;
                }

                entity.Attributes.push(newAttr);
            }
        }

        else if (format == "json") {
            if (true) { //typeof (entity[attributeName]) != "undefined") { // eigentlich ist ja egal wenns das noch nicht gibt??
                //entity[attributeName] = value;
                this._setNestedProperty(entity, attributeName, value);
                attrFound = true;
            }
        }
    }
    _setNestedProperty(obj: any, path: any, value: any): any {
        var parts = (path || '').split('.');
        // using 'every' so we can return a flag stating whether we managed to set the value.
        return parts.every(function (p: any, i: any) {
            if (!obj) return false; // cancel early as we havent found a nested prop.
            if (i === parts.length - 1) { // we're at the final part of the path.
                obj[parts[i]] = value;
            } else {
                obj = obj[parts[i]]; // overwrite the functions reference of the object with the nested one.
            }
            return true;
        });
    }
    getEntityAttributeValue(entity: any, attributeName: any, overrideStructureFormat?: any, sourceEntity?: any): any {
        //console.log("search for attribute " + attributeName);
        if (entity == null) {
            return null;
        }

        if (!sourceEntity) sourceEntity = entity;

        let format = this._structureFormat;

        if (overrideStructureFormat == "json" || overrideStructureFormat == "pit") {
            format = overrideStructureFormat;
        }

        // immer noch kein Format? automatisch ermitteln veruschen:
        if (!format) {
            if (entity.Attributes) {
                if (typeof (entity.Attributes.length) == "number") {
                    format = "pit";
                }
            }

            if (!format) {
                format = "json";
            }
        }


        if (format == "pit") {

            for (var iIndex = 0; iIndex < entity.Attributes.length; iIndex++) {
                var attribute = entity.Attributes[iIndex];

                if (attribute.Name == attributeName) {

                    //  wenn blödes json-datum, dann als echtes javascript-datum ausgeben
                    //
                    if (typeof (attribute.Value) == "string") {
                        if (attribute.Value.indexOf("/Date(") == 0) {
                            if (attribute.Value != null) {
                                return new Date(parseInt(attribute.Value.substr(6)));
                            }
                        }
                    }

                    return attribute.Value;
                }
            }

            console.log("Warning: Couldn't find attribute " + attributeName + " in " + entity.Classname);
        }

        else if (format == "json") {
            var attributePath = attributeName.split('.'); // array mit dem komplexen Attributstring
            if (attributePath.length < 1) {
                console.warn("Warning: Invalid attribute '" + attributeName + "' in json-entity", entity, "from source: " + sourceEntity);
                return;
            }
            var currentAttribute = attributePath[0];
            if (typeof (entity[currentAttribute]) != "undefined") {

                (window as any).attrFound = true; // JS2TS: 'attrFound' undeclared in this method in the original (leaked global) — preserved
                var value = entity[currentAttribute];

                if (attributePath.length > 1) // es gibt unterebenen!
                {
                    if (typeof (value) == "object") {
                        // die nächsten Ebenen zusammenbauen und rekursiv aufrufen
                        var subAttributes = "";

                        for (var i = 1; i < attributePath.length; i++) {

                            if (i > 1) {
                                subAttributes = subAttributes + ".";
                            }
                            subAttributes = subAttributes + attributePath[i];
                        }
                        //console.log("PitHelper getnextlevel", subAttributes);
                        return this.getEntityAttributeValue(value, subAttributes, "json", sourceEntity);
                    }
                }

                //  wenn blödes json-datum, dann als echtes javascript-datum ausgeben
                //
                if (typeof (value) == "string") {
                    if (value.indexOf("/Date(") == 0) {
                        if (value != null) {
                            return new Date(parseInt(value.substr(6)));
                        }
                    }
                }

                return value;
            }

            else {
                console.warn("Warning: Couldn't find attribute '" + attributeName + "' in json-entity", entity);
            }
        }
    }

    getEntityAttributeValueDateString(entity: any, attributeName: any): any {
        var value = this.getEntityAttributeValue(entity, attributeName);

        return dojoDateLocale.format(value, { locale: 'de-de', datePattern: "dd.MM.yyyy", timePattern: "HH:mm" })
    }

    IsDarkColor(color: any): any {
        return (1 * color.BValue +
            2 * color.RValue +
            3 * color.GValue)
            <= 6 * 128;
    }
}
PitHelper.prototype.declaredClass = 'ServicePortal.PitHelper';

export default mdsWidget(PitHelper);
